import React from 'react';
import logo from "@/assets/images/logo.png";

const BreakSuggestionModal = ({ isOpen, onTakeBreak, onContinue }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-[#eae5d6] z-[99999] flex items-center justify-center overflow-hidden">
      <div className="min-h-screen w-full max-w-full flex flex-col items-center justify-center p-2 sm:p-6 text-center overflow-x-hidden">
        <div className="mb-6 sm:mb-12 w-full max-w-full">
          <div className="flex justify-center mb-4 sm:mb-6">
            <img
              src={logo}
              alt="PostScrypt Logo"
              className="h-10 sm:h-16 w-auto max-w-[90%]"
            />
          </div>
        </div>

        <h2 className="text-[#FF6B4A] text-xl sm:text-3xl font-medium mb-3 sm:mb-8 w-full px-2">
          Why not take a break?
        </h2>

        <p className="text-gray-900 text-lg sm:text-3xl mb-3 sm:mb-8 w-full px-2">
          You&apos;ve been working hard!
        </p>

        <div className="max-w-md w-full px-2 sm:px-4">
          <p className="text-gray-600 text-xs sm:text-base break-words">
            Would you like to take a break and continue later, or keep going?
          </p>
        </div>

        <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4 mt-6 sm:mt-12 w-full sm:w-auto px-2 sm:px-0 max-w-[95%]">
          <button
            onClick={onTakeBreak}
            className="bg-[#FF6B4A] text-white px-4 sm:px-8 py-2 sm:py-3 rounded-full hover:bg-[#E55D3D] transition-colors flex items-center justify-center gap-2 w-full sm:w-[160px] md:w-[180px] text-sm sm:text-base"
          >
            <span className="truncate">Take a Break</span>
            <svg
              className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.75 6.75L19.25 12L13.75 17.25"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19 12H4.75"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          <button
            onClick={onContinue}
            className="border border-[#FF6B4A] text-[#FF6B4A] px-4 sm:px-8 py-2 sm:py-3 rounded-full hover:bg-gray-50 transition-colors w-full sm:w-[160px] md:w-[180px] text-sm sm:text-base"
          >
            <span className="truncate">Continue</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BreakSuggestionModal;